import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import SEO from '../components/SEO';

interface LegalPageProps {
  type: 'privacy' | 'tos';
}

const LegalPage: React.FC<LegalPageProps> = ({ type }) => {
  const isPrivacy = type === 'privacy';

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <SEO 
        title={isPrivacy ? 'Privacy Policy' : 'Terms of Service'}
        description={isPrivacy ? 'Read our privacy policy to understand how we handle your data.' : 'Our terms of service for using Chasing TCG.'}
      />
      <Paper elevation={0} sx={{ p: 6, borderRadius: 4, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
          {isPrivacy ? 'Privacy Policy' : 'Terms of Service'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last Updated: March 3, 2026
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {isPrivacy ? (
          <Box className="legal-content">
            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>1. Information We Collect</Typography>
            <Typography variant="body1" paragraph>
              We collect information you provide directly to us when you create an account, such as your email address. We also collect data about your TCG collection that you manually input into our system.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>2. How We Use Your Information</Typography>
            <Typography variant="body1" paragraph>
              We use the information we collect to maintain your collection tracker, provide market analytics, and send restock alerts (if opted-in). We do not sell your personal data to third parties.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>3. Cookies and Advertising</Typography>
            <Typography variant="body1" paragraph>
              We use local storage and cookies to maintain your session and preferences. We may use third-party advertising services (like Google AdSense) which may use cookies to serve ads based on your visits to this and other websites.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>4. Data Security</Typography>
            <Typography variant="body1" paragraph>
              We use industry-standard encryption and security measures to protect your data. However, no method of transmission over the internet is 100% secure.
            </Typography>
          </Box>
        ) : (
          <Box className="legal-content">
            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>1. Acceptance of Terms</Typography>
            <Typography variant="body1" paragraph>
              By accessing or using Chasing TCG, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>2. Use License</Typography>
            <Typography variant="body1" paragraph>
              Permission is granted to temporarily use the professional tools provided by Chasing TCG for personal, non-commercial collection tracking only.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>3. Disclaimer</Typography>
            <Typography variant="body1" paragraph>
              The market data and prices provided are for informational purposes only. We do not guarantee the accuracy or timeliness of TCGPlayer or marketplace pricing data.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>4. Limitations</Typography>
            <Typography variant="body1" paragraph>
              In no event shall Chasing TCG or its suppliers be liable for any damages arising out of the use or inability to use the materials on our website.
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default LegalPage;
